module.exports = __webpack_public_path__ + "static/img/zh_CN2.d0ac916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zh_CN2.png
// module id = RUNy
// module chunks = 1